import { render, staticRenderFns } from "./BgSoundModel.vue?vue&type=template&id=8a066d0a&scoped=true"
import script from "./BgSoundModel.vue?vue&type=script&lang=js"
export * from "./BgSoundModel.vue?vue&type=script&lang=js"
import style0 from "./BgSoundModel.vue?vue&type=style&index=0&id=8a066d0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a066d0a",
  null
  
)

export default component.exports